Object.defineProperty(exports, "__esModule", { value: true });
exports.registerFieldAfterHook = exports.registerFieldBeforeHook = exports.fieldAfterHooksRegistry = exports.fieldBeforeHooksRegistry = void 0;
const error_1 = require("./error");
const DeepWeakMap_1 = require("../../services/utils/deepWeakMap/DeepWeakMap");
exports.fieldBeforeHooksRegistry = new DeepWeakMap_1.DeepWeakMap();
exports.fieldAfterHooksRegistry = new DeepWeakMap_1.DeepWeakMap();
function registerFieldBeforeHook(target, fieldName, hook) {
    if (!hook) {
        throw new error_1.HookError(target, fieldName, `Field @Before hook function must be supplied.`);
    }
    const currentHooks = exports.fieldBeforeHooksRegistry.get(target, fieldName) || [];
    exports.fieldBeforeHooksRegistry.set(target, fieldName, [hook, ...currentHooks]);
}
exports.registerFieldBeforeHook = registerFieldBeforeHook;
function registerFieldAfterHook(target, fieldName, hook) {
    if (!hook) {
        throw new error_1.HookError(target, fieldName, `Field @After hook function must be supplied.`);
    }
    const currentHooks = exports.fieldAfterHooksRegistry.get(target, fieldName) || [];
    exports.fieldAfterHooksRegistry.set(target, fieldName, [hook, ...currentHooks]);
}
exports.registerFieldAfterHook = registerFieldAfterHook;
//# sourceMappingURL=registry.js.map